<template>
  <footer class="zui-footer">
    <div class="footer-main">
      <div class="footer-main-item flex-noraml">
        <div class="footer-item-title">关注我们</div>
        <div class="footer-item-content">
          <div class="mp-item">
            <img class="mp-img" src="../../assets/img/footer/gongzh.jpg"/>
            <div class="mp-img-text">微信公众号</div>
          </div>
          <div class="mp-item">
            <img class="mp-img" src="../../assets/img/footer/mp.jpg"/>
            <div class="mp-img-text">官方店铺</div>
          </div>
        </div>
      </div>
      <div class="footer-main-item flex-noraml">
        <div class="footer-item-title">
          服务电话
        </div>
        <div class="footer-item-content flex-column">
          <div class="tel">市场部：<br/>13576298878</div>
          <div class="tel">技术部：<br/>15070933375</div>
        </div>
      </div>
      <div class="footer-main-item flex-noraml">
        <div class="footer-item-title">
          常用链接
        </div>
        <div class="footer-item-content">
          <div class="links">
            <a href="/">预约平台</a>
            <a href="/">艺见饰界</a>
            <a href="/">回到首页</a>
            <a href="/">后台管理</a> <!--  @click="goto"-->
           <!--<a href="/link">联系我们</a>-->
          </div>
        </div>
      </div>
    </div>

    <div class="copy-right">
      <div style="margin-right: 10px;">Copyright © Korlinor paint, 2023, All Rights Reserved</div>
      <a class="beian" data-component="a2-text-link" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
        <div class="text-link-label">
          <span>沪ICP备2023016851号-2</span>
        </div>
      </a>
      <a target="_blank" href="" class="gongan">
        <img src="" style="float:left;"/>
        <div class="text-link-label">
          <span></span>
        </div>
      </a>
    </div>
  </footer>
</template>
<script>
  import '../../assets/less/footer.less'
  export default {
    methods:{
      goto(){
        this.$router.push({
          path:'/login'
        })
      }
    }
  }
</script>
